import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from './api.service';
import { JwtService } from './jwt.service';
import { UserService } from './user.service';
//import { start } from 'repl';

@Injectable()
export class PatientService {
  myTodoCount: number;
  userFilter: boolean = true;
  CN_id: string;
  userId: string;
  showDrop: boolean = true;
  private imageSource = new BehaviorSubject<any>('');
  navItem$ = this.imageSource.asObservable();
  private mytodo = new BehaviorSubject<any>('');
  public Mytodo = this.mytodo.asObservable().pipe(distinctUntilChanged());
  us_Patient: boolean = true;
  public todoDeatils: any;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private jwtService: JwtService,
    private userService: UserService
  ) { }

  // Verify JWT in localstorage with server & load user's info.
  // This runs once on application startup.
  getmytodolist(userId): Observable<[any]> {
    const obj = {
      "loginUaId": userId,
      "selectedCnUaId": this.CN_id,
      "startDateRange": 'N',
      "endDateRange": 'N',
    }
    let data = this.userService.encrypt(JSON.stringify(obj))
    return this.apiService.post('/api/v2/todo/allTodoList', { data })
      .map(data => data);
  }
  todolistbyrange(obj): Observable<[any]> {
    let data = this.userService.encrypt(JSON.stringify(obj))
    return this.apiService.post('/api/v2/todo/allTodoList', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  //todo-config
  getTodoMapByClient(clientId, userAccountId): Observable<[any]> {
    let data: any = {
      "clientId": clientId,
      "loginUaId": userAccountId,
      "selectedCnUaId": this.CN_id
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/care/getTodoMapByClient', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  countrange(userId, startrange, endrange) {
    let data: any = {
      "userAccountId": userId,
      "cNUserId": this.CN_id,
      "startDateRange": startrange,
      "endDateRange": endrange
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/care/getCountDetails', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  //message unread
  markasunread(patSWFID, ccId, portal) {
    let data = {
      "patientSwfId": patSWFID,
      "ccUserAccountId": ccId,
      "portal": portal
    }
    return this.apiService.post('/api/v2/message/unReadMessage', data)
      .map(data => data);
  }
  //et mytodo count from reasin filter
  getCountDetailsRaTodoOverLapFilter(obj) {
    let data = this.userService.encrypt(JSON.stringify(obj))
    return this.apiService.post('/api/v2/todo/getCountDetailsRaTodoOverLapFilter', { data })
      .map(data => this.userService.decrypt(data.data));
  }

  gettodocompleted(userId): Observable<[any]> {
    let obj = {
      'loginUaId': userId,
      'selectedCnUaId': this.CN_id
    }
    let data = this.userService.encrypt(JSON.stringify(obj))
    return this.apiService.post('/api/v2/todo/allCompletedTodoList', { data })
      .map(data => data);
  }
  gettodolist(userid, Id) {
    let data: any = {
      'loginUaId': Id,
      'selectedCnUaId': this.CN_id,
      'startDateRange': 'N',
      'endDateRange': 'N',
      'todoCategoryId': userid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/todo/todoListByCategoryId', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getcountqual(def, id, ccid) {
    let data: any = {
      'qualificationType': def,
      'loginUaId': id,
      'cNUserId': ccid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post(`/api/v2/commercial/getBundlePatientDetailsByStage`, { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getCountDetails(userId) {
    let data: any = {
      "userId": userId,
      "cNUserId": this.CN_id,
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/care/getCountDetails', { data })
      .map(data => this.userService.decrypt(data.data));
  }

  transactionList(userid, Id) {
    let data: any = {
      "clientId": Id,
      "requestedBy": userid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/reports/getDownloadTransactionList', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  gettransactionList(userid) {
    let data: any = { "requestedBy": userid }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/reports/getCompletedCarePlanRequestCount', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  reassigncn(reassign) {

    return this.apiService.post(`/api/v2/care/updateReassignPatient/`, reassign)
      .map(data => data);
  }
  puttransactionList(requestedBy) {
    return this.apiService.post('/api/v2/reports/updateCompletedCarePlanViewStatus', { requestedBy })
      .map(data => data);
  }
  getappvisible(userid, tocatid, userRole) {
    let data: any = {
      "patientSwfId": userid,
      "todoCategoryId": tocatid,
      "pracOrHsp": userRole,
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/cc/dashboard/isTodoAssignedToBasedOnTodoCategory', { data })
      .map(data => this.userService.decrypt(data.data));
  }

  getpatimage(userid) {
    return this.apiService.get('/api/v2/onboard/getonbaordpatientimage/' + userid)
      .map(data => data);
  }
  getuserdetails(userid, uid) {
    let data: any = {
      "patientSwfId": userid,
      "userId": uid
    }
    data = this.userService.encrypt(JSON.stringify(data));
    return this.apiService.post('/api/v2/cc/dashboard/getPatientDetails', { data })
      .map(data => this.userService.decrypt(data.data))
  }
  getuserid(patid) {
    let data: any = {
      "patientId": patid
    }
    data = this.userService.encrypt(JSON.stringify(data));
    return this.apiService.post('/api/v2/care/PatientDetails', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getPatientPassword(email, uid): Observable<any> {
    let self = this;
    let data: any = {
      "userName": email,
      "userId": uid
    }
    data = this.userService.encrypt(JSON.stringify(data));
    return self.apiService.post(`/api/getpwd`, { data })
      .map(data => this.userService.decrypt(data.data))

  }

  /* gettodolist(userid){
      return this.apiService.get('api/v2/todo/todoListByCategoryId?todoCategoryId='+userid)
     .map(data => data);
   } */
  /* getBundlePatientDetails(id): Observable<[any]> {
   return this.apiService.get(`/api/v2/commercial/getBundlePatientDetails`)
          .map(data => data);
 } */
  getBundlePatientDetails(id, type): Observable<[any]> {
    let data = {
      'qualificationType': type,
      'loginUaId': id,
      'cNUserId': this.CN_id
    }
    return this.apiService.post(`/api/v2/commercial/getBundlePatientByQualificationType`, data)
      .map(data => data);
  }
  getReasonCodeDetailsList() {
    return this.apiService.post(`/api/v2/commercial/getReasonCodeDetailsList`)
      .map(data => this.userService.decrypt(data.data));
  }
  getNotesList(bundlePatientId) {
    return this.apiService.post(`/api/v2/commercial/getBundlePatientNotes`, { bundlePatientId })
      .map(data => data);
  }
  getQNotesList(id) {
    let data: any = {
      "bundlePatientId": id
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/commercial/getQualificationNotesHistory', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getStageQualificationDetails(groupId): any {
    let data: any = {
      "groupId": groupId
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/commercial/getStageQualificationDetailsByGroupId', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getStageTabQualificationDetails(groupId): any {
    return this.apiService.post(`/api/v2/commercial/getQualificationDetailsByGroupId`, { groupId })
      .map(data => data);
  }
  getPatientFacility(id, acid): Observable<[any]> {
    let arg = {
      'bundlePatientId': id,
      'userAccountId': acid
    }
    return this.apiService.post(`/api/v2/commercial/getBundlePatientFacilityList`, arg)
      .map(data => data);
  }
  getBundlePatientDetailsid(bundlePatientId): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/commercial/getBundlePatientByBundlePatientId`, { bundlePatientId })
      .map(data => data)
  }
  reviewBundlePatientDetailsid(id, userid): Observable<any> {
    let self = this;
    let arg = {
      'bundlePatientId': id,
      'loginUaId': userid
    }
    return self.apiService.post(`/api/v2/commercial/reviewBundlePatient`, arg)
      .map(data => data)
  }
  postBundlePatientDetailsid(data): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/commercial/updateBundlePatients`, data)
      .map(data => data)
  }
  getpatientlist(id, mode): Observable<[any]> {
    let data: any = {
      "userAccountId": id,
      "cNUserId": this.CN_id,
      "mode": mode
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post(`/api/v2/care/ccpatientlistsub`, { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getccmessages(id, mode): Observable<[any]> {
    let data: any = {
      "userAccountId": id,
      "cNUserId": this.CN_id,
      "mode": mode
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/care/ccPatientInfoForMessages', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  otherpac(hspOrPracId): Observable<[any]> {
    return this.apiService.post(`/api/v2/cc/dashboard/fetchHospitalOtherPacMap`, { hspOrPracId })
      .map(data => data);
  }
  getcurrentdate(): Observable<[any]> {
    return this.apiService.post('/api/getCurrentDate')
      .map(data => data);
  }
  getccmessagesinfo(swfid, mode): Observable<[any]> {
    let data: any = {
      "patientSwfId": swfid,
      "isCcORPatientPortal": mode
    }
    data = this.userService.encrypt(JSON.stringify(data));
    return this.apiService.post('/api/v2/message/fetchPatientWithMessages', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getppmessagesinfo(ccid, swfid, mode, type): Observable<[any]> {
    let data: any = {
      "ccUserAccountId": ccid,
      "patientSwfId": swfid,
      "isCcORPatientPortal": mode,
      "type": type
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/message/fetchPatientWithccMessages', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  savemsg(msg) {
    let data = this.userService.encrypt(JSON.stringify(msg))
    return this.apiService.post('/api/v2/message/saveTwoWayMessageSentByCc', { data })
      .map(data => data);
  }
  savecomment(msg) {
    return this.apiService.post('/api/v2/commercial/saveBundleNotes', msg)
      .map(data => data);

  }
  updatePreferredFacility(id, list) {
    list.loginUaId = id
    return this.apiService.post(`/api/v2/commercial/updatePreferredFacility`, list)
      .map(data => data);

  }
  updateEnroll(id, accid, list) {
    list.bundlePatientId = id
    list.loginUserId = accid
    list.preQualified = false
    return this.apiService.post(`/api/v2/care/enrollPatient`, list)
      .map(data => data);

  }
  savedownload(data) {
    return this.apiService.post('/api/v2/reports/saveDashboardTransaction', data)
      .map(data => data);
  }
  postdisqualifi(data) {
    return this.apiService.post(`/api/v2/commercial/disQualifyPatient`, data)
      .map(data => data);
  }
  savefacilitypack(id, data) {
    data.userAccountId = id
    return this.apiService.post(`/api/v2/commercial/saveBundleFacilityList`, data)
      .map(data => data);
  }
  bodypartsave(data, frac, swfid, key) {
    let self = this;
    let arg = {
      'procedureType': data,
      'fracture': frac,
      'patientSwfId': swfid,
      'userAccountId': key
    }
    return self.apiService.post(`/api/v2/care/changeProcedureType`, arg)
      .map(data => data);
  }
  savemsgpp(msg) {
    let data = this.userService.encrypt(JSON.stringify(msg))
    return this.apiService.post('/api/v2/message/saveTwoWayMessageSentByPatient', { data })
      .map(data => data);
  }
  getpatientdos(data) {
    return this.apiService.post('/api/v2/message/createNewMessage', data)
      .map(data => data);
  }
  /* getpatientmessage(parameter) {
    return this.apiService.post('/api/v2/care/ccmessages_new',parameter)
           .map(data => data);
  } */
  getpatientemail(patientSWFId, account, type) {
    let data = {
      "patientSwfId": patientSWFId,
      "userAccountId": account,
      "type": type
    }
    return this.apiService.post('/api/v2/care/resendEmailLinkGeneration', data)
      .map(data => data);
  }

  getpatientmessage() {
    return this.apiService.get('/api/v2/care/ccmessages')
      .map(data => data);
  }
  getpatientreport(): Observable<[any]> {
    return this.apiService.get('/api/v2/care/ccmessages')
      .map(data => data);
  }
  getpatientappointments(id, mode): Observable<[any]> {
    let data: any = {
      "userAccountId": id,
      "cNUserId": this.CN_id,
      "mode": mode
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/care/ccappointmentlist', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getpatients_report_list() {
    return this.apiService.post('/api/v2/patientreports/patients_report_list')
      .map(data => data);
  }

  filterReports(hospital, serve) {
    let self = this;
    let data = {
      "hospitalId": hospital,
      "servId": serve
    }
    return self.apiService.post('/api/v2/patientreports/patients_reportlist_byHSP', data)
      .map(data => data);
  }

  getpatients_report_landing() {
    return this.apiService.post('/api/v2/patientreports/patients_report_landing')
      .map(data => data);
  }

  getBodyLocation(key): Observable<any> {
    let data: any = {
      "userAccountKey": key
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post(`/api/v2/care/getServicelineByPracticeId`, { data })
      .map(data => this.userService.decrypt(data.data))
  }

  getPayorTypeList(key): Observable<any> {
    let self = this;
    let data: any = {
      "practiceId": key
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post(`/api/v2/care/getPayorTypeByPractice`, { data })
      .map(data => this.userService.decrypt(data.data))
  }

  
  getClientLanguageConfig(clientId) {
    return this.apiService.post(`/api/v2/care/getLanguageConfigByClient/${clientId}`)
  }
  getBundlepartType(key, id): Observable<any> {
    let self = this;
    let data = {
      'payorId': id,
      'practiceId': key
    }
    return self.apiService.post(`/api/v2/commercial/getbundleprocedurelist`, data)
      .map(data => data)
  }
  getBodypartLocation(key): Observable<any> {
    // not used
    let self = this;
    return self.apiService.get(`/api/v2/care/getNewServicelineByPracticeId/${key}`)
      .map(data => data)
  }

  getSurgeonlist(id): Observable<any> {
    let self = this;
    let data: any = {
      "userAccountId": id
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post(`/api/v2/care/getsurgeonlist`, { data })
      .map(data => this.userService.decrypt(data?.data))
  }

  getSurgeonUserId(id): Observable<any> {
    let self = this;
    let data = {
      'surgeonId': id
    }
    return self.apiService.post(`/api/v2/care/getsurgeonByUserAccId`, data)
      .map(data => data)
  }
  getselcode(id): Observable<any> {
    let self = this;
    let data: any = {
      "hospitalId": id
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post(`/api/commonctrl/fetchCountryCodeByHspOrPracId`, { data })
      .map(data => this.userService.decrypt(data.data))
  }
  getAlterNo(): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/care/otherphonentype`)
      .map(data => data)
  }

  getimageid(userAccountId): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/onboard/getOnBoardUserImage`, { userAccountId })
      .map(data => data)
  }

  getbilateral(patid, bodypart, side, dos): Observable<any> {
    let self = this;
    let data = {
      'patientId': patid,
      'carepath': bodypart,
      'laterality': side,
      'dos': dos
    }
    return self.apiService.post(`/api/v2/care/checkPatientServiceLineExistForBilateral`, data)
      .map(data => data)
  }

  getHospitalList(id): Observable<any> {
    let self = this;
    let data: any = {
      "userAccountId": id
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post(`/api/v2/care/gethospitallist`, { data })
      .map(data => this.userService.decrypt(data.data))
  }
  getHospitalListbyPayor(payorid, id, surgid): Observable<any> {
    let self = this;
    let data: any = {
      'payorId': payorid,
      'userAccountKey': id,
      'surgeonId': surgid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post(`/api/v2/care/getHospitalListByPayor`, { data })
      .map(data => data)
  }

  addNewPatient(data, userAccountId, commercial, skipenroll): Observable<any> {
    let self = this;
    data.surgeonId = data.AddBodyPart[0].surgeonId;
    data.proceduretype = data.AddBodyPart[0].carePath.toString();
    data.payortype = data.AddBodyPart[0].payorType;
    data.proceduretype = data.proceduretype.slice(1, -1)
    data.userAccountId = userAccountId
    data.commercialType = commercial
    data.preQualified = skipenroll
    ////console.log(carePath, "Payor")
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post(`/api/v2/care/getconfigurePatientDetailsV1`, { data })
      .map(data => this.userService.decrypt(data.data))
  }
  getbundletype() {
    let self = this;
    return self.apiService.post(`/api/v2/commercial/payortypelists`)
      .map(data => data)
  }
  getBundlePatientPayorInfo(email) {
    let self = this;
    return self.apiService.post(`/api/v2/care/getBundlePatientPayorInfo`, { email })
      .map(data => data)
  }
  getSurgicalLocation(hospitalid, payorid) {
    let self = this;
    let data: any = {
      "practiceId": hospitalid,
      "payorId": payorid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post(`/api/v2/care/getSurgicalLocationByPracticeAndPayor`, { data })
      .map(data => this.userService.decrypt(data.data));
  }
  SummaryUpdateProfile(patientId, data) {
    data.patientId = patientId
    data = this.userService.encrypt(JSON.stringify(data));
    return this.apiService.post('/api/v2/care/getSummaryUpdateProfile', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  patdas(data) {
    return this.apiService.post('/api/v2/commercial/saveBundlePatientDashboard', data)
      .map(data => data)
  }
  Procedureupdate(data): Observable<any> {
    let self = this;
    return self.apiService.post('/api/v2/care/changeProcedureDetails', data)
      .map(data => data)
  }
  getPatientEmailExist(email, id): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/care/getemailexists/`, { email })
      .map(data => data)
  }
  getUserExist(data, id): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/care/getUserExists`, data)
      .map(data => data)
  }
  getDeactivePatientExist(patdetails, id): Observable<any> {
    let self = this;
    let data = this.userService.encrypt(JSON.stringify(patdetails))
    return self.apiService.post(`/api/v2/care/getPatientHistory`, { data })
      .map(data => this.userService.decrypt(data.data))
  }
  getBundleEmailExists(email, id): Observable<any> {
    let mail = {
      email: email,
      bundlePatientId: id
    }
    let self = this;
    return self.apiService.post(`/api/v2/care/getemailexists`, mail)
      .map(data => data)
  }
  getPatientDelEmailExist(email): Observable<any> {
    let self = this;
    let arg = {
      email: email
    }
    let data = this.userService.encrypt(JSON.stringify(arg))
    return self.apiService.post('/api/v2/care/getdeletedstatus', { data })
      .map(data => this.userService.decrypt(data.data))
  }

  getBodyPartServiceAvailable(carePath, laterality, surgid): Observable<any> {
    let self = this;
    let data: any = {
      "carepath": carePath,
      "laterality": laterality,
      "surgeonId": surgid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/care/getStageWorkflowIsOrNo', { data })
      .map(data => this.userService.decrypt(data.data))
  }

  getSnfList(): Observable<any> {
    let self = this;
    let data: any = {
      "dischargeType": 3
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/care/getdischargeLocType', { data })
      .map(data => this.userService.decrypt(data.data))
  }

  getFacilityList(pracid): Observable<any> {
    let self = this;
    let data: any = {
      "practiceId": pracid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/commercial/getUnApprovedFacilities', { data })
      .map(data => data)
  }

  checkPatientMrnExist(mrn, hospitalId): Observable<any> {
    let self = this;
    let data = {
      'mrn': mrn,
      'hospitalId': hospitalId
    }
    return self.apiService.post(`/api/v2/care/getmrnexists`, data)
      .map(data => data)
  }

  checkPatientSsnExists(ssn): Observable<any> {
    let self = this;
    let data = {
      'ssn': ssn
    }
    return self.apiService.post(`/api/v2/care/getssnexists`, data)
      .map(data => data)
  }

  chenckPatientPhoneExists(phone, uid): Observable<any> {
    let self = this;
    let data = {
      "hospitalId": uid,
      "phoneNumber": phone
    }
    return self.apiService.post(`/api/v2/care/getphonenoexists`, data)
      .map(data => data)
  }

  checkPatienExists(patientExist): Observable<any> {
    let self = this;
    let data = this.userService.encrypt(JSON.stringify(patientExist))
    return self.apiService.post(`/api/v2/care/getpatientexistsV1`, { data })
      .map(data => this.userService.decrypt(data.data))
  }

  insertArchivedPatientExist(patientExist): Observable<any> {
    let self = this;
    let data = this.userService.encrypt(JSON.stringify(patientExist))
    return self.apiService.post(`/api/v2/care/initiatecReInsertArchivedPatient`, { data })
  }

  getAppoinmentsListwitSWFid(patientSWFId): Observable<any> {
    let self = this;
    let data: any = {
      "patientSwfId": patientSWFId
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/appointment/fetchPatientAppointments', { data })
      .map(data => this.userService.decrypt(data.data))
  }

  saveAppoinments(data, loginHospitalId, patswfid): Observable<any> {
    let self = this;
    data.hospitalId = loginHospitalId
    data.patientSwfId = patswfid
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/appointment/savePatientAppointment', { data })
      .map(data => this.userService.decrypt(data.data))
  }

  cardets(data) {
    return this.apiService.post('/api/v2/care/getCareGiverUpdate', data)
      .map(data => data)
  }

  cancelAppoinments(arg): Observable<any> {
    let self = this;
    arg.strykerAdminId = window.localStorage['superClientId'] ? window.localStorage['superClientId'] : 0
    let data = this.userService.encrypt(JSON.stringify(arg))
    return self.apiService.post(`/api/v2/appointment/cancelPatientAppointment`, { data })
      .map(data => this.userService.decrypt(data.data))
  }

  //   getPatientBasicDetails(data) {
  //     let self = this;
  //     return self.apiService.post(`/api/v2/patientreports/patients_reports_survey_landing?patId=${data.patId}&bodypartname=${data.bodypartname}&proceduretype=
  // ${data.proceduretype}`)
  //       .map(data => data);
  //   }

  getPatientSurveyList(patid) {
    let self = this;
    return self.apiService.post('/api/v2/patientreports/patients_reports_surveys_list', { patid })
      .map(data => data);
  }
  getpatientdetails(patientId) {
    let data: any = {
      "patientId": patientId
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/care/getSummaryProfile', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getpatientinfo(patientId, patientSWFId) {
    let data: any = {
      "patientId": patientId,
      "patientSwfId": patientSWFId,
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/care/getSummaryPatientInfo', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getnewpatientinfo(patientId) {
    return this.apiService.post('/api/v2/commercial/getBundlePatientDashboardData', { patientId })
      .map(data => data);
  }
  postdocuments(data) {
    let self = this;
    return self.apiService.post('/api/v2/care/getSavePatientScanDoc', data)
      .map(data => data);
  }
  postattachment(data, portal) {
    let self = this;
    data.portal = portal
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post(`/api/v2/message/saveAttachment`, { data })
      .map(data => data);
  }
  getProMailContent(patSurveyId, clientId) {
    let self = this;
    let data = {
      'patSurveyId': patSurveyId,
      'clientId': clientId
    }
    return self.apiService.post(`/api/v2/care/getProMailContent`, data)
      .map(data => data);
  }
  sendProMailReminder(patSurveyId, clientId, loginUserId, data) {
    let self = this;
    data.patSurveyId = patSurveyId
    data.clientId = clientId
    data.loginUaId = loginUserId

    return self.apiService.post(`/api/v2/care/sendProMailReminder`, data)
      .map(data => data);
  }
  editdocuments(data) {
    let self = this;
    return self.apiService.put('/api/v2/care/getSavePatientScanDocUpdate', data)
      .map(data => data);
  }
  getdocuments(patientId, patientSWFId) {
    return this.apiService.get('/api/v2/care/getPatientScanDocDetails/' + patientId + '/' + patientSWFId)
      .map(data => data);
  }
  // getSurveyDetails(data) {
  //   let self = this;
  //   return self.apiService.post(`/api/v2/patientreports/patient_reports_survey_detail_view?resultid=${data.resultId}&bodypartname=${data.bodyname}&proceduretype=${data.proceduretype}`)
  //     .map(data => data);
  // }

  getCarePlanAssessments(id): Observable<any> {
    let self = this;
    let data: any = {
      "patientSwfId": id
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/cc/dashboard/fetchCarePlanAssesments', { data })
      .map(data => this.userService.decrypt(data.data))
  }
  getdescription(patientswfid): Observable<any> {
    let self = this;
    let data: any = {
      "patientSwfId": patientswfid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/cc/dashboard/displayDashboardLatestCpNote', { data })
      .map(data => this.userService.decrypt(data.data))
  }
  getContactHistory(id, ccid): Observable<any> {
    let self = this;
    let data: any = {
      "patientSwfId": id,
      "title": "Message",
      "ccUserAccountId": ccid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/cc/dashboard/fetchDashboardTweetsByPatientSwfId', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getContacttrigger(patientSwfId, ccid): Observable<any> {
    let self = this;
    let data: any = {
      "patientSwfId": patientSwfId,
      "title": "Trigger Message",
      "ccUserAccountId": ccid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/cc/dashboard/fetchDashboardTweetsByPatientSwfId', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getNotesHistory(patientSwfId, ccUserAccountId): Observable<any> {
    let self = this;
    let data: any = {
      "patientSwfId": patientSwfId,
      "title": "NotesHistory",
      "ccUserAccountId": ccUserAccountId
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/cc/dashboard/fetchDashboardTweetsByPatientSwfId', { data })
      .map(data => this.userService.decrypt(data.data));
  }

  getCarePlanDetails(id, uid): Observable<any> {
    let self = this;
    let data: any = {
      "patientSwfId": id,
      "userId": uid,
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/cc/dashboard/fetchDashboardCarePlan', { data })
      .map(data => data);
  }
  getPlannedDischargeDate(uid) {
    let self = this;
    let data: any = {
      'patientSwfId': uid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post(`/api/v2/cc/dashboard/fetchConfigurablePlannedDischargeDate`, { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getHospitalPlannedDischargeDateInterval(hid, swfid) {
    let self = this;
    let data: any = {
      "hospitalId": hid,
      "patientSwfId": swfid,
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/cc/dashboard/fetchPlannedDichargeDateByDayValue', { data })
      .map(data => this.userService.decrypt(data.data))
  }
  getMyTodoList(id, userRole, mytodostatus, startdate, enddate, loginHspId, userAccountId): Observable<any> {
    let self = this;
    let data: any = {
      "patientSwfId": id,
      "pracOrHsp": userRole,
      "todoViewMode": mytodostatus,
      "startDateRange": startdate,
      "endDateRange": enddate,
      "loginHspOrPracId": loginHspId,
      "dropDownUaId": this.CN_id
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/cc/dashboard/fetchDashboardMyTodo', { data })
      .map(data => this.userService.decrypt(data.data))
  }
  newrangeapi(id, userRole, mytodostatus, startdate, enddate): Observable<any> {
    let self = this;
    let data: any = {
      "patientSwfId": id,
      "pracOrHsp": userRole,
      "todoViewMode": mytodostatus,
      "startDateRange": startdate,
      "endDateRange": enddate
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/cc/dashboard/fetchDashboardMyTodo', { data })
      .map(data => this.userService.decrypt(data.data))
  }


  getPatsum(id, swfid): Observable<any> {
    let self = this;
    let data: any = {
      "patientId": id,
      "patientSwfId": swfid,
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/care/getpatdetails', { data })
      .map(data => this.userService.decrypt(data.data));
  }



  addContactHistory(data): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/cc/dashboard/saveContactHistory`, data)
      .map(data => data)
  }
  savepactype(data): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/cc/dashboard/saveOrUpdateOtherPac`, data)
      .map(data => data)
  }
  saveothertodo(data): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/cc/dashboard/saveOrSnoozeCustomTodo`, data)
      .map(data => data)
  }
  addcustom(data): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/cc/dashboard/saveCustomTodoForMultiPatients`, data)
      .map(data => data)
  }
  deleteothertodo(patswfid, todocareplansurveyid, todoid): Observable<any> {
    let self = this;
    let arg = {
      'patientSwfId': patswfid,
      'todoCarePlanSurveyId': todocareplansurveyid,
      'todoCategoryId': todoid
    }
    return self.apiService.post(`/api/v2/cc/dashboard/deleteTodoCarePlanSurveyById`, arg)
      .map(data => data)
  }
  markAsReadtodo(pswid, categoryId, surveyCode, hpsmId, careplansurveyid, startdate, enddate) {
    let self = this;
    let auditData: any;
    this.userService.currentUser.subscribe(data => {
      auditData = data;
    });
    let data = {
      patientSwfId: pswid,
      categoryId: categoryId,
      surveyCode: surveyCode,
      hspsmId: hpsmId,
      todoCarePlanSurveyId: careplansurveyid,
      startDateRange: startdate,
      endDateRange: enddate,
      superClientId: window.localStorage['superClientId'] ? window.localStorage['superClientId'] : auditData.item.userAccountId
    }
    return self.apiService.post(`/api/v2/cc/dashboard/updateDashboardCarePlanTodo`, data)
      .map(data => data)
  }

  updateccviewd(patid, hpsmId, surveyCode, categoryId, careplansurveyid, startdate, enddate) {
    let self = this;
    let auditData: any;
    this.userService.currentUser.subscribe(data => {
      auditData = data;
    });
    let data = {
      superClientId: window.localStorage['superClientId'] ? window.localStorage['superClientId'] : auditData.item.userAccountId,
      patientSwfId: patid,
      categoryId: categoryId,
      surveyCode: surveyCode,
      hspsmId: hpsmId,
      todoCarePlanSurveyId: careplansurveyid,
      startDateRange: startdate,
      endDateRange: enddate
    }
    return self.apiService.post(`/api/v2/cc/dashboard/updateDashboardCarePlanTodoAfterCcViewed`, data)
      .map(data => data)
  }
  updateccreviewd(patid, hpsmId, surveyCode, categoryId, careplansurveyid, startdate, enddate) {
    let self = this;
    let auditData: any;
    this.userService.currentUser.subscribe(data => {
      auditData = data;
    });
    let data = {
      patientSwfId: patid,
      categoryId: categoryId,
      surveyCode: surveyCode,
      hspsmId: hpsmId,
      todoCarePlanSurveyId: careplansurveyid,
      startDateRange: startdate,
      endDateRange: enddate,
      superClientId: window.localStorage['superClientId'] ? window.localStorage['superClientId'] : auditData.item.userAccountId
    }
    return self.apiService.post(`/api/v2/cc/dashboard/updateDashboardCarePlanTodoAfterCcReviewed`, data)
      .map(data => data)
  }
  passchange(pass) {
    let self = this;
    pass.newpswd = btoa(pass.newpswd)
    let data = this.userService.encrypt(JSON.stringify(pass))
    return self.apiService.post(`/api/v2/onboard/getUserPassWordUpdate`, { data })
      .map(data => this.userService.decrypt(data.data))
  }
  pwdHistroy(uId, pwdvalue) {
    let self = this;
    let arg = {
      userAccountId: uId,
      userPassword: btoa(pwdvalue)
    }
    let data = this.userService.encrypt(JSON.stringify(arg))
    return self.apiService.post(`/api/savePwdHistory`, { data })
      .map(data => this.userService.decrypt(data.data))
  }
  chkPass(pass) {
    let self = this;
    let arg = {
      encodedSecurityDict: btoa(pass)
    }
    return self.apiService.post(`/api/isValidSecurityDict`, arg)
      .map(data => data)
  }
  lastpass(uId, pwdvalue) {
    let self = this;
    let arg = {
      userAccountId: uId,
      userPassword: btoa(pwdvalue)
    }
    let data = this.userService.encrypt(JSON.stringify(arg));
    return self.apiService.post(`/api/isLastUsedPassword`, { data })
      .map(data => this.userService.decrypt(data.data))
  }

  getcarepath(patientId, patientSwfId): Observable<any> {
    let self = this;
    let data: any = {
      "patientId": patientId,
      "patientSwfId": patientSwfId,
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/care/getpatCarePathDetails', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getcarefamily(id, swfid): Observable<any> {
    // not used
    let self = this;
    return self.apiService.get(`/api/v2/care/getpatCareFamilyDetails/${id}/${swfid}`)
      .map(data => data)
  }
  getcarelist(patId): Observable<any> {
    let self = this;
    let data: any = {
      "patientId": patId
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/care/getSummaryCarepartnerlist', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getpatapp(patId, patientSwfId): Observable<any> {
    let self = this;
    let data: any = {
      "patientId": patId,
      "patientSwfId": patientSwfId,
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/care/getpatAppoinementsDetails', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getapp(swfid): Observable<any> {
    let self = this;
    let data: any = {
      "patientSwfId": swfid,
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/care/getSummaryAppointments', { data })
      .map(data => this.userService.decrypt(data.data));
  }
  getbio(id): Observable<any> {
    let self = this;
    let data: any = {
      "patientId": id,
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/care/getBioGraph', { data })
      .map(data => this.userService.decrypt(data.data));
  }

  savequestion(data) {
    return this.apiService.post('/api/v2/onboard/updateprofilequestions', data)
      .map(data => data);
  }

  getprofile(userAccountId): Observable<any> {
    let self = this;
    let arg = {
      userAccountId: userAccountId
    }
    let data = this.userService.encrypt(JSON.stringify(arg))
    return self.apiService.post('/api/v2/onboard/getprofilequestions', { data })
      .map(data => this.userService.decrypt(data.data))
  }
  getname(id): Observable<any> {
    //not used 
    let self = this;
    return self.apiService.get(`/api/v2/onboard/getOnBoardThankyou/${id}`)
      .map(data => data)
  }




  getact(patswfid): Observable<any> {
    let self = this;
    let data = {
      "patientSwfId": patswfid,
    }
    return self.apiService.post('/api/v2/care/getSummaryActivityBoard', data)
      .map(data => data)
  }
  getepisodeid(patswfvalue): Observable<any> {
    let self = this;
    let data = {
      "patientSwfId": patswfvalue,
    }
    return self.apiService.post('/api/v2/care/getPatientCurrentEpisodeDetails', data)
      .map(data => data)
  }

  getcarepart(addCarePartner): Observable<any> {
    let self = this;
    let data = this.userService.encrypt(JSON.stringify(addCarePartner))
    return self.apiService.post(`/api/v2/care/getSummaryaddcarepartner`, { data })
      .map(data => this.userService.decrypt(data.data))
  }

  uploadimage(addimage): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/onboard/updateUserUploadImg`, addimage)
      .map(data => data)
  }
  getquesti(ans, id, activation): Observable<any> {
    let self = this;
    ans.activation = activation ? activation : false;
    ans.randId = id
    let data = this.userService.encrypt(JSON.stringify(ans))
    return self.apiService.post(`/api/v2/onboard/saveSecurityQuestions`, { data })
      .map(data => this.userService.decrypt(data.data))
  }
  getsecques(ans): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/checkUserSelectedFirstQuestnAndAnswer`, ans)
      .map(data => data)
  }

  getotpuser(otp): Observable<any> {
    let self = this;
    return self.apiService.post(`/getconfrimOTPtoUser`, otp)
      .map(data => data)
  }
  getotp(sms): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/getconfrimOTPtoUserForgetPassword`, sms)
      .map(data => data)
  }
  validOTP(sms): Observable<any> {
    let self = this;
    let data = this.userService.encrypt(JSON.stringify(sms))
    return self.apiService.post(`/api/validateOtp`, { data })
      .map(data => this.userService.decrypt(data.data))
  }


  // saveCarePlan(id,data,type,dos):Observable<any>{
  //   let self = this;
  //   let startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] :'N' ;
  //   let enddate = window.localStorage['enddate'] ?window.localStorage['enddate'] :'N' ;
  //   return self.apiService.post(`/api/v2/cc/dashboard/saveDashboardCarePlan/${id}/${type}/${dos}/${startdate}/${enddate}`,data)
  // }

  saveCarePlan(id, data, type, dos, userId): Observable<any> {
    let self = this;
    data[0]['patientSwfId'] = id
    data[0]['saveType'] = type
    data[0]['dosAtPv'] = dos
    data[0]['startDateRange'] = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
    data[0]['endDateRange'] = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';
    data[0]['userId'] = userId
    data[0]['cnAccountId'] = this.CN_id
    return self.apiService.post(`/api/v2/cc/dashboard/saveDashboardCarePlan`, data)
  }


  savePlan(key, plan, id): Observable<any> {
    let self = this;
    let data = {
      "hospitalId": key,
      "dischargeType": plan,
      "dischargeTo": id
    }
    return self.apiService.post('/api/v2/cc/dashboard/savePlannedOtherFacilty', data)
  }
  ftechQuickView(todoInfoBean) {
    let self = this;
    let data = {
      "loginHspOrPracId": todoInfoBean
    }
    return self.apiService.post('/api/v2/todo/fetchQuickViewTodoWithAssociates', data)
  }
  ftechTodoListView(loginHspOrPracId, patientSwfId) {
    let self = this;
    let data = {
      "loginHspOrPracId": loginHspOrPracId,
      "patientSwfId": patientSwfId
    }
    return self.apiService.post('/api/v2/todo/fetchTodoWithAssociates', data)
  }
  getwelcome(id, dob): Observable<any> {
    let self = this;
    let data: any = {
      "randId": id,
      "dob": dob
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/onboard/getEmailWelcome', { data })
      .map(data => this.userService.decrypt(data.data))
  }
  validateDOB(userName, id, dob): Observable<any> {
    let self = this;
    let data: any = {
      "userName": userName,
      "dob": dob,
      "patientId": id
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/validateDOB', { data })
      .map(data => this.userService.decrypt(data.data))
  }
  getwelcomepat(randId): Observable<any> {
    let self = this;
    let data: any = {
      randId: randId
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post(`/api/v2/onboard/getPatientWelcomeInfo`, { data })
      .map(data => this.userService.decrypt(data.data))
  }
  getuserotp(userAccountId, comType, mode): Observable<any> {
    let self = this;
    let data: any = {
      "userAccountId": userAccountId,
      "comType": comType,
      "mode": mode
    }
    return self.apiService.post('/api/sendTemporaryPassword', data)
      .map(data => data)
  }
  getquestions(): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/onboard/getSecurityQuestionList`)
      .map(data => this.userService.decrypt(data.data))
  }
  getselectedquestions(username): Observable<any> {
    let self = this;
    return self.apiService.post('/api/getUserSelectedQuestnAndAnswerList', { username })
      .map(data => data)
  }
  getsecurity(mail): Observable<any> {
    let self = this;
    return self.apiService.post('/api/getUserSelectedQuestnAndAnswerList', { mail })
      .map(data => data)
  }

  getBlock(userAccountId): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/blockUserAccount`, { userAccountId })
      .map(data => data)
  }
  getwelcom(randId): Observable<any> {
    let self = this;
    let data: any = {
      "randId": randId
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/onboard/getEmailWelcome', { data })
      .map(data => this.userService.decrypt(data.data))
  }

  getaccount(userAccountId): Observable<any> {
    let self = this;
    return self.apiService.post(`/getSendOtp`, { userAccountId })
      .map(data => data)
  }
  getacid(userAccountId): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/getSendOtpForgotPassword`, { userAccountId })
      .map(data => data)
  }

  gettrack(swfid): Observable<any> {
    let self = this;
    return self.apiService.post('/api/v2/care/cctrackactivities', { swfid })
      .map(data => data)
  }
  getgivertype(): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/care/getSummaryCareGiverType`)
      .map(data => data)
  }
  getgivername(userGroupId, patientId, patientSWFId): Observable<any> {
    let self = this;
    let arg = {
      'userGroupId': userGroupId,
      'patientId': patientId,
      'patientSwfId': patientSWFId
    }
    return self.apiService.post(`/api/v2/care/getSummaryCareGiverName`, arg)
      .map(data => data)
  }

  getSuveryUserDetais(patId, PatSwfId): Observable<any> {
    let self = this;
    let data = {
      "patientId": patId,
      "patientSwfId": PatSwfId
    }
    return self.apiService.post('/api/v2/cc/dashboard/fetchSurveyPatientInfo', data)
      .map(data => data)
  }

  getSurveyDetailsbySurevy(surveyId, PatSwfId, oldresult): Observable<any> {
    let self = this;
    let data = {
      "patientSurveyMappingId": surveyId,
      "pswfId": PatSwfId,
      "oldResultId": oldresult
    }
    return self.apiService.post('/api/v2/cc/dashboard/fetchsurveyresult', data)
      .map(data => data)
  }

  getSurveyDetailsbySurevydate(surveyId): Observable<any> {
    let self = this;
    let data: any = {
      "patientSurveyMappingId": surveyId
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/survey/getViewSurveyAssignDateInfo', { data })
      .map(data => this.userService.decrypt(data.data))
  }

  getSurveyassigndate(surveyId, swfid): Observable<any> {
    let self = this;
    let data: any = {
      "patientSurveyMappingId": surveyId,
      "pswfId": swfid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/survey/getViewSurveyAssignDateInfo', { data })
      .map(data => this.userService.decrypt(data.data))
  }
  addSinglePart(arg, userid, skipenroll): Observable<any> {
    let self = this;
    arg.loginUserId = userid;
    arg.preQualified = skipenroll
    let data = this.userService.encrypt(JSON.stringify(arg))
    return self.apiService.post(`/api/v2/care/configureNewBodyPart`, { data })
      .map(data => data)
  }
  //get workflow episode by workflow id 
  /**
   * 
   * @param workflowId workflow Id
   */
  getWorkflowStages(workflowId): Observable<any> {
    let self = this;
    return self.apiService.post('/api/v2/admin/workflow/tab', { workflowId })
  }

  getStagesMaterials(epidosdeId): Observable<any> {
    let self = this;
    return self.apiService.post('/api/v2/admin/workflow/tabdetails', { epidosdeId })
  }

  changeNav(image) {
    this.imageSource.next(image);
  }
  savepac(swfid, id, data): Observable<any> {
    // not used
    let self = this;
    return self.apiService.post(`/api/v2/cc/dashboard/savePac/${swfid}/${id}`, data)
      .map(data => data)
  }

  updatePacProgress(swfid, data): Observable<any> {
    // not used
    let self = this;
    return self.apiService.post(`/api/v2/cc/dashboard/updatePatientInProgress/${swfid}`, data)
      .map(data => data)
  }
  pacview(swfid): Observable<any> {
    // not used 
    let self = this;
    return self.apiService.get(`/api/v2/cc/dashboard/fetchPac/${swfid}`)
      .map(data => data)
  }
  GcpBe(swfid): Observable<any> {
    let self = this;
    let data: any = {
      "patientSwfId": swfid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/cc/dashboard/isGcpBeyondTheTimelineDate', { data })
      .map(data => this.userService.decrypt(data.data))
  }
  pacviews(swfid): Observable<any> {
    let self = this;
    // not used
    return self.apiService.get(`/api/v2/cc/dashboard/fetchPac/${swfid}`)
      .map(datas => datas)
  }


  upadtepac(swfid, uid, data)//not used
  {
    return this.apiService.put(`/api/v2/cc/dashboard/updatePac/${swfid}/${uid}`, data)
      .map(data => data);
  }
  terminatepac(swfid) {
    return this.apiService.post('/api/v2/cc/dashboard/validateIfTerminatePAC', { swfid })
      .map(data => data);
  }
  deletepac(m_chr_id, plannedHspTransfer, actualHspTransfer, loginUserAccountId) {
    let arg = {
      'patientPacMasterMapId': m_chr_id,
      'dischargeTypeId': plannedHspTransfer,
      'trackActual': actualHspTransfer,
      'loginUaId': loginUserAccountId
    }
    return this.apiService.post(`/api/v2/cc/dashboard/deletePac`, arg)
      .map(data => data);
  }
  showpopother(uid, plan, id): Observable<any> {
    let self = this;
    let data = {
      "hospitalId": uid,
      "dischargeType": plan,
      "dischargeTo": id
    }
    return self.apiService.post('/api/v2/cc/dashboard/savePlannedOtherFacilty', data)
  }
  getvisitdetails(uid): Observable<any> {
    let self = this;
    return self.apiService.post('/api/v2/cc/dashboard/fetchCareVisitDetails', { uid })
  }
  getcustomtodo(id, careplanid, catid): Observable<any> {
    let self = this;
    let arg = {
      'patientSwfId': id,
      'todoCarePlanSurveyId': careplanid,
      'todoCategoryId': catid
    }
    return self.apiService.post(`/api/v2/cc/dashboard/fetchTodoCarePlanSurveyById`, arg)
  }


  /* changelength(mytodo) {
    mytodo = window.localStorage['mytodolength']
  }
  changemsglength(msg) {
    msg = window.localStorage['msg']
  } */


  /* attemptAuth( credentials): Observable<User> {
    return this.apiService.post('/authsession', credentials)
    .map(
      data => {
        this.setAuth(data);
        return data;
      }
    );
  }
  updatepass(user): Observable<User> {
    return this.apiService
    .put('/user/updateuserpwd', user )
    .map(data => {
      // Update the currentUser observable
      return data;
    });
  } */


  /** Reschedule and Cancel service start here */


  cancelSurgery(id, userAccountId): Observable<any> {
    let self = this;
    let data = {
      'patientSwfId': id,
      'userAccountId': window.localStorage['superClientId'] ? window.localStorage['superClientId'] : userAccountId
    }
    return self.apiService.post(`/api/v2/cc/bundle/cancelSurgery`, data)
      .map(data => data)
  }

  rescheduleDOS(reschedulePlan): Observable<any> {
    let self = this;
    return self.apiService.post(`/api/v2/cc/bundle/rescheduleDOS`, reschedulePlan)
  }
  /**** Fetch DashboardCarePlanDischargeList */

  fetchDashboardCarePlanDischargeList(uid): Observable<any> {
    let self = this;
    let data: any = {
      "userId": uid
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/cc/dashboard/fetchDashboardCarePlanDischargeList', { data })
      .map(data => this.userService.decrypt(data.data))
  }

  configureEventTypeFetch(hospitalId): Observable<any> {
    let self = this;
    let data: any = {
      "hospitalId": hospitalId
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post('/api/v2/cc/dashboard/fetchConfiguredDischargeTypeVisitByHospital', { data })
      .map(data => this.userService.decrypt(data.data))
  }

  getExersiseVideo(patientSWFId): Observable<any> {
    let data: any = {
      "patientSwfId": patientSWFId
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/patient/getActivityVideos', { data })
      // .map(data => this.userService.decrypt(data.data))
  }

  //192.168.5.184:8080/rc9/api/v2/patient/getUserByEmail?email=cc_mcare%40ripplecare.com
  getUserByEmail(EmailId: any): Observable<any> {
    let self = this;
    return self.apiService.post('/api/v2/patient/getUserByEmail', { EmailId })
  }
  getEpisodeAppointmenthospitallist(userAccountId, patientSWId) {
    let self = this;
    let data: any = {
      "loginUaId": userAccountId,
      "patientSwfId": patientSWId
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post(`/api/v2/care/getEpisodeAppointmenthospitallist`, { data })
      .map(data => this.userService.decrypt(data.data))
  }



  getTodoConfigurationStatus(reAssignPatModel) {
    let self = this;
    return self.apiService.post('/api/v2/care/getTodoConfigurationStatus', reAssignPatModel)
  }

  checkIfOtherAppmntNameAlreadyExists(userAccountKey, event) {
    let self = this;
    let data = {
      'hospitalId': userAccountKey,
      'otherHospitalName': event
    }
    return self.apiService.post(`/api/v2/appointment/checkIfOtherAppmntNameAlreadyExists`, data)
  }

  //Patient SWF History for Deactivate
  getPatientSWFHistory(patientId, pswIsActive) {
    let data: any = {
      "patientId": patientId,
      "patientSwfId": pswIsActive
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return this.apiService.post('/api/v2/onboard/bodyPartList', { data })
      .map(data => this.userService.decrypt(data.data));
  }

  //Reassign Todo Service

  fetchTodoRAHospitalOverlapSurgeons(userAccountKey, dropdownCN) {
    let self = this;
    let data = {
      "loginUaId": userAccountKey,
      "dropDownUaId": dropdownCN
    }
    return self.apiService.post(`/api/v2/todo/fetchTodoRAHospitalOverlapSurgeons`, data)
  }

  fetchTodoRAPracticeOverlapHospitals(userAccountKey, dropdownCN) {
    let self = this;
    let data: any = {
      "loginUaId": userAccountKey,
      "dropDownUaId": dropdownCN
    }
    data = this.userService.encrypt(JSON.stringify(data))
    return self.apiService.post(`/api/v2/todo/fetchTodoRAPracticeOverlapHospitals`, { data })
  }

  fetchTodoRAHospitalHNSurgeons(userAccountKey) {
    let self = this;
    let data = {
      "loginUaId": userAccountKey
    }
    return self.apiService.post(`/api/v2/todo/fetchTodoRAHospitalHNSurgeons/`, data)
  }

  fetchTodoRAPracticePCHospitals(userAccountKey) {
    let self = this;
    return self.apiService.get(`/api/v2/todo/fetchTodoRAPracticePCHospitals/` + userAccountKey)
  }

  getReassignTodoCNforSurgeon(userAccountId, overLab, selectedhspUnderSurgeonId, selectHosId) {
    let self = this;
    let data = {
      "loginUaId": userAccountId,
      "selectedPracticeOverlap": overLab,
      "overlapSelectedPracticeId": selectedhspUnderSurgeonId,
      "nonOverlapSelectedSosId": selectHosId
    }
    return self.apiService.post('/api/v2/todo/fetchRACareUserListForTodoHospitalOverlap', data)
  }

  getReassignTodoCNforHospital(userAccountId, overLab, selectHosId) {
    let self = this;
    let data = {
      "loginUaId": userAccountId,
      "selectedPracticeOverlap": overLab,
      "nonOverlapSelectedSosId": selectHosId
    }
    return self.apiService.post('/api/v2/todo/fetchRACareUserListForTodoPracticeOverlap', data)
  }

  postTodoReassign(reassignTodo) {
    let self = this;
    return self.apiService.post('/api/v2/todo/reAssignTodo', reassignTodo)
  }

  postoverlaphspsurg(obj1) {
    let self = this;
    return self.apiService.post(`/api/v2/todo/fetchRaTodoOverlapPreRequisiteInfo`, obj1)
  }

}
